<template>
  <div class="spacer">
    <svg
      :style="{ display: isPortrait ? 'none' : 'block' }"
      id="visual"
      viewBox="0 0 960 300"
      style="width: 100%"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      version="1.1"
    >
      <rect x="0" width="960" height="390" y="0" fill="#000"></rect>
      <path
        d="M0 162L16 170.2C32 178.3 64 194.7 96 199.7C128 204.7 160 198.3 192 197.2C224 196 256 200 288 198C320 196 352 188 384 190.7C416 193.3 448 206.7 480 211.2C512 215.7 544 211.3 576 212C608 212.7 640 218.3 672 212.8C704 207.3 736 190.7 768 191.3C800 192 832 210 864 210.8C896 211.7 928 195.3 944 187.2L960 179L960 0L944 0C928 0 896 0 864 0C832 0 800 0 768 0C736 0 704 0 672 0C640 0 608 0 576 0C544 0 512 0 480 0C448 0 416 0 384 0C352 0 320 0 288 0C256 0 224 0 192 0C160 0 128 0 96 0C64 0 32 0 16 0L0 0Z"
        fill="#6e1869"
      ></path>
      <path
        d="M0 139L16 146C32 153 64 167 96 175.7C128 184.3 160 187.7 192 182.5C224 177.3 256 163.7 288 153C320 142.3 352 134.7 384 131.2C416 127.7 448 128.3 480 135C512 141.7 544 154.3 576 162C608 169.7 640 172.3 672 173.2C704 174 736 173 768 171.5C800 170 832 168 864 171.3C896 174.7 928 183.3 944 187.7L960 192L960 0L944 0C928 0 896 0 864 0C832 0 800 0 768 0C736 0 704 0 672 0C640 0 608 0 576 0C544 0 512 0 480 0C448 0 416 0 384 0C352 0 320 0 288 0C256 0 224 0 192 0C160 0 128 0 96 0C64 0 32 0 16 0L0 0Z"
        fill="#9e0861"
      ></path>
      <path
        d="M0 98L16 105.2C32 112.3 64 126.7 96 126.3C128 126 160 111 192 107.3C224 103.7 256 111.3 288 108.5C320 105.7 352 92.3 384 83.8C416 75.3 448 71.7 480 80C512 88.3 544 108.7 576 112.2C608 115.7 640 102.3 672 92.3C704 82.3 736 75.7 768 79.3C800 83 832 97 864 106.3C896 115.7 928 120.3 944 122.7L960 125L960 0L944 0C928 0 896 0 864 0C832 0 800 0 768 0C736 0 704 0 672 0C640 0 608 0 576 0C544 0 512 0 480 0C448 0 416 0 384 0C352 0 320 0 288 0C256 0 224 0 192 0C160 0 128 0 96 0C64 0 32 0 16 0L0 0Z"
        fill="#c5174d"
      ></path>
      <path
        d="M0 48L16 48.2C32 48.3 64 48.7 96 52C128 55.3 160 61.7 192 67.8C224 74 256 80 288 80.7C320 81.3 352 76.7 384 75.3C416 74 448 76 480 72.5C512 69 544 60 576 58.2C608 56.3 640 61.7 672 64C704 66.3 736 65.7 768 67.2C800 68.7 832 72.3 864 67.8C896 63.3 928 50.7 944 44.3L960 38L960 0L944 0C928 0 896 0 864 0C832 0 800 0 768 0C736 0 704 0 672 0C640 0 608 0 576 0C544 0 512 0 480 0C448 0 416 0 384 0C352 0 320 0 288 0C256 0 224 0 192 0C160 0 128 0 96 0C64 0 32 0 16 0L0 0Z"
        fill="#000"
      ></path>
    </svg>
  </div>
</template>
<script setup>
const isPortrait = inject("isPortrait");
</script>
<style lang="scss" scoped>
.spacer {
  background-color: #000;
  width: 100%;
}
</style>
